import { Label } from "../ui/label";
import { Field } from "../../pages/public/Register";
import { useReference } from "../../lib/reference";

export const EMAIL_OK = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);
export const PHONE_OK = (v) => /^[0-9+()./\s-]{6,30}$/.test(v);
export const URL_OK = (v) => !v || /^https?:\/\/\S+$/.test(v);

export function validateCompany(f) {
  const e = {};
  if (f.legal_name.trim().length < 2) e.legal_name = "Raison sociale requise";
  if (f.name.trim().length < 2) e.name = "Nom commercial requis";
  if (f.sector.trim().length < 2) e.sector = "Secteur requis";
  if (f.country.trim().length < 2) e.country = "Pays requis";
  if (!f.city.trim()) e.city = "Ville requise";
  if (f.address.trim().length < 3) e.address = "Adresse requise";
  if (!PHONE_OK(f.phone)) e.phone = "Téléphone invalide (6 à 30 chiffres)";
  if (!EMAIL_OK(f.email)) e.email = "Email professionnel invalide";
  if (!URL_OK(f.website)) e.website = "L'adresse doit commencer par http:// ou https://";
  if (f.billing.billing_email && !EMAIL_OK(f.billing.billing_email)) e.billing_email = "Email de facturation invalide";
  return e;
}

export const CompanyFieldset = ({ f, setF, errors, lockLegal }) => {
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const ref = useReference();
  return (
    <fieldset className="grid gap-4 sm:grid-cols-2">
      <datalist id="ref-sectors">{ref?.sectors.map((s) => <option key={s.code} value={s.label} />)}</datalist>
      <datalist id="ref-countries">{ref?.countries.map((s) => <option key={s.code} value={s.label} />)}</datalist>
      <legend className="mb-3 font-display font-semibold">Organisation</legend>
      <Field id="company-legal-name" label="Raison sociale" value={f.legal_name} onChange={set("legal_name")} error={errors.legal_name} disabled={lockLegal} />
      <Field id="company-name" label="Nom commercial" value={f.name} onChange={set("name")} error={errors.name} />
      <Field id="company-sector" label="Secteur d'activité" value={f.sector} onChange={set("sector")} error={errors.sector} list="ref-sectors" placeholder="Banque, Santé, Mairie…" />
      <div><Label>Type</Label>
        <select className="field-select mt-1.5" value={f.org_type} onChange={set("org_type")} data-testid="company-org-type-select"><option value="prive">Privé</option><option value="public">Public</option></select>
      </div>
      <Field id="company-country" label="Pays" value={f.country} onChange={set("country")} error={errors.country} list="ref-countries" />
      <Field id="company-city" label="Ville" value={f.city} onChange={set("city")} error={errors.city} />
      <div className="sm:col-span-2"><Field id="company-address" label="Adresse" value={f.address} onChange={set("address")} error={errors.address} /></div>
      <Field id="company-phone" label="Téléphone" type="tel" value={f.phone} onChange={set("phone")} error={errors.phone} />
      <Field id="company-email" label="Email professionnel" type="email" value={f.email} onChange={set("email")} error={errors.email} disabled={lockLegal} />
      <div className="sm:col-span-2"><Field id="company-website" label="Site web (facultatif)" value={f.website} onChange={set("website")} error={errors.website} placeholder="https://" /></div>
    </fieldset>
  );
};

export const BillingFieldset = ({ f, setF, errors }) => {
  const set = (k) => (e) => setF({ ...f, billing: { ...f.billing, [k]: e.target.value } });
  return (
    <fieldset className="grid gap-4 sm:grid-cols-2">
      <legend className="mb-3 font-display font-semibold">Facturation (facultatif)</legend>
      <Field id="billing-name" label="Nom de facturation" value={f.billing.billing_name} onChange={set("billing_name")} />
      <Field id="billing-email" label="Email de facturation" type="email" value={f.billing.billing_email} onChange={set("billing_email")} error={errors.billing_email} />
      <Field id="billing-address" label="Adresse de facturation" value={f.billing.billing_address} onChange={set("billing_address")} />
      <Field id="billing-tax-id" label="N° fiscal / identifiant entreprise" value={f.billing.tax_id} onChange={set("tax_id")} />
    </fieldset>
  );
};

export const EMPTY_COMPANY = { legal_name: "", name: "", sector: "", org_type: "prive", country: "", city: "", address: "", phone: "", email: "", website: "",
  billing: { billing_name: "", billing_address: "", billing_email: "", tax_id: "" } };
